export default {
      id: "links-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#links",
      toString: function () {
        return this.url;
      }
    }